import { render, staticRenderFns } from "./EditorLayoutContent.vue?vue&type=template&id=0da9d78a&"
import script from "./EditorLayoutContent.vue?vue&type=script&lang=js&"
export * from "./EditorLayoutContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports